import React, {useEffect, useState} from "react";

import ActsService from "../../services/acts.service";
import {Alert, Breadcrumb, Button, Col, Row} from "react-bootstrap";
import ActItem from "../acts/actItem.component";
import AuthService from "../../services/auth.service";
import Container from "react-bootstrap/Container";
import {isLoggedIn} from "../../common/utils";
import {API_EDITS_ALLOWED} from "../../services/axios.utils";

const MyActsList = () => {
    const [acts, setActs] = useState([])

    const fetchActs = (user_id) => {
        ActsService.getActsByCreator(user_id).then(
            response => {
                setActs(response.data.data);
                console.log("my acts:" + JSON.stringify(response.data.data));
            },
            error => {
                console.log(error);
            });
    }

    // load once on mount to fetch all acts
    useEffect(() => {
        let user = AuthService.getCurrentUser();
        fetchActs(user.id);
    }, []);

    let user = AuthService.getCurrentUser();
    let loggedIn = isLoggedIn();
    let editsAllowed = API_EDITS_ALLOWED === "true" || (loggedIn && user.is_admin);

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h3>
                        <Breadcrumb>
                            <Breadcrumb.Item active>My Acts</Breadcrumb.Item>
                        </Breadcrumb>
                    </h3>
                </Col>
                <Col>
                    <div className="float-end">
                        {(user !== null && (user.is_performer || user.is_admin)) &&
                            <Button href="/acts/new" disabled={!editsAllowed}>New Act</Button>
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Alert>
                        <div>
                            These are the acts you've created.
                        </div>
                    </Alert>

                    {acts.length === 0 &&
                        <div>You have not created any acts yet. Use the New Act button to create an act.</div>
                    }
                    {acts.length > 0 &&
                        acts.map((act) =>
                            <ActItem key={act.id} act={act}/>
                        )
                    }
                </Col>
            </Row>
        </Container>
    );
};

export default MyActsList;
